import { render } from "./IdFront.vue?vue&type=template&id=6a800268"
import script from "./IdFront.vue?vue&type=script&lang=js"
export * from "./IdFront.vue?vue&type=script&lang=js"

import exportComponent from "../../../../app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__